import { render, staticRenderFns } from "./uldList.vue?vue&type=template&id=48b45cc2&scoped=true&"
import script from "./uldList.vue?vue&type=script&lang=js&"
export * from "./uldList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b45cc2",
  null
  
)

export default component.exports